import React from 'react';
import { ICON_FAMILIES, ICON_GLYPHMAPS, IconTypeValue } from './glyphMaps';

export interface FontIconProps {
    type: IconTypeValue;   // which library
    name: string;          // icon name from that glyph map (e.g., "home", "account", "bell")
    size?: number;         // px
    title?: string;
    style?: React.CSSProperties;
}

export const FontIcon: React.FC<FontIconProps> = (props) => {
    const family = ICON_FAMILIES[props.type];
    const map = ICON_GLYPHMAPS[props.type];
    const cp = map?.[props.name];

    if (family == null || map == null || cp == null) return null;

    // Convert numeric codepoint to a glyph
    const glyph = String.fromCodePoint(cp);

    const fontSize = props.size ?? 22;

    return (
        <span
            className="icon-font"
            title={props.title ?? props.name}
            style={{
                fontFamily: family,
                fontSize,
                lineHeight: `${fontSize}px`,
                display: 'inline-block',
                ...(props.style ?? {}),
            }}
        >
            {glyph}
        </span>
    );
};
